import { render, staticRenderFns } from "./PcfLinkek.vue?vue&type=template&id=dcbe43fc&"
import script from "./PcfLinkek.vue?vue&type=script&lang=js&"
export * from "./PcfLinkek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports